import DataTable from "react-data-table-component";
import React from "react";
import { Button, Col, Row } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  setBalanceDetailsLimit,
  setBalanceDetailsPage,
} from "../../../../redux/actions/reports/reportsAction";
import {
  checkPassword,
  settleAccountBalance,
} from "../../../../redux/actions/api/apiAction";
import { CheckPassword } from "../../../../components/modals/checkPassword";
import { store } from "../../../../redux/storeConfig/store";
import { setCheckPasswordModalOpen } from "../../../../redux/actions/staff/staffAction";
import PaymentTypesDialog from "./paymentTypesDialog";
import { toastr } from "react-redux-toastr";
import moment from "moment";

export const BalanceReportDetails = () => {
  const { details, detailsCount } = useSelector((state) => state.report);
  const [showCheckPasswordDialog, setShowCheckPasswordDialog] = React.useState(
    false
  );
  const [showPaymentDialog, setShowPaymentDialog] = React.useState(false);
  const [currentTransactionType, setCurrentTrancationType] = React.useState(
    "L"
  );
  const [currentRemainingAmount, setCurrentRemainingAmount] = React.useState(0);

  const [memberData, setMemberData] = React.useState({});
  const dispatch = useDispatch();

  const handleResetRemaingMount = (
    transactionType,
    cardProcessingFees,
    recievedAmount,
    paymentStatus
  ) => {
    let { member, membership } = memberData;
    /** Validation  */
    if (!paymentStatus || !transactionType) {
      toastr.error(
        "Please Select Full or Partial Transaction or Transcation Type."
      );
      return;
    }
    if (paymentStatus === "P" && recievedAmount > membership.remainingAmount) {
      toastr.error(
        "Received Amount should not be greater than Remaining Amount."
      );
      return;
    }

    dispatch(
      settleAccountBalance({
        member,
        membership,
        transactionType,
        cardProcessingFees,
        recievedAmount,
        paymentStatus,
      })
    );
  };

  const checkPasswordAction = async (password) => {
    try {
      let flag = await store.dispatch(checkPassword(password));
      if (!flag) throw new Error("Incorrect Password");
      // here will show dialog for payment types:
      setShowPaymentDialog(true);
    } catch (e) {
      console.log(e.message);
    } finally {
      dispatch(setCheckPasswordModalOpen(!showCheckPasswordDialog));
      setShowCheckPasswordDialog(false); // for hide dialog
    }
  };
  const columns = [
    {
      name: "Package Name",
      selector: (row) => row?.packageName || "MockData",
      sortable: true,
    },
    {
      name: "Created At",
      selector: (row) =>
        moment(row.createdAt).format("DD/MM/YYYY h:mm A") || "",
      sortable: true,
      width: "200px",
    },
    {
      name: "Package Start Date",
      selector: (row) =>
        moment(row.startDate).format("DD/MM/YYYY") || "",
      sortable: true,
      width: "200px",
    },
    {
      name: "Package End Date",
      selector: (row) => moment(row.endDate).format("DD/MM/YYYY") || "",
      sortable: true,
      width: "200px",
    },
    {
      name: "Package Price",
      selector: (row) => row?.packagePrice?.toLocaleString() || "0",
      sortable: true,
    },
    {
      name: "Final Price",
      selector: (row) =>
        (row?.packagePrice * (1 - row?.discount / 100))?.toLocaleString() ||
        "0",
      sortable: true,
    },
    {
      name: "Discount",
      selector: (row) => row?.discount?.toLocaleString() || "0",
      sortable: true,
    },
    {
      name: "Received Amount",
      selector: (row) => row?.recievedAmount?.toLocaleString() || "0",
      sortable: true,
    },
    {
      name: "Remaining Amount",
      selector: (row) => row?.remainingAmount?.toLocaleString() || "0",
      sortable: true,
    },
    {
      name: "Actions",
      selector: (row) => (
        <Button
          className="settle-btn"
          onClick={() => {
            dispatch(setCheckPasswordModalOpen(!showCheckPasswordDialog)); // for chekComponent
            setShowCheckPasswordDialog(true); // for showing dialog
            setMemberData({ member: row?.member, membership: row?.membership });
            setCurrentTrancationType(row?.transactionType);
            setCurrentRemainingAmount(row?.remainingAmount);
          }}
          disabled={!row?.remainingAmount}
        >
          Settle
        </Button>
      ),
      sortable: true,
    },
  ];

  return (
    <Row>
      <Col xs={12} className="mt-4">
        {details && (
          <DataTable
            responsive
            className="dark-blue-table"
            columns={columns}
            data={details}
            pagination
            paginationServer
            paginationTotalRows={detailsCount}
            onChangeRowsPerPage={(newLimit) =>
              dispatch(setBalanceDetailsLimit(newLimit))
            }
            onChangePage={(newPage) => dispatch(setBalanceDetailsPage(newPage))}
          />
        )}
        {showCheckPasswordDialog && (
          <CheckPassword handleSubmit={checkPasswordAction} />
        )}
        {showPaymentDialog && (
          <PaymentTypesDialog
            modalFlg={showPaymentDialog}
            toggle={setShowPaymentDialog}
            currentTransactionType={currentTransactionType}
            hanldeSubmit={handleResetRemaingMount}
            type="settelment"
            currentRemainingAmount={currentRemainingAmount}
          />
        )}
      </Col>
    </Row>
  );
};
